function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import TreeSet from '../../../../java/util/TreeSet';
import Geometry from './Geometry';
import Arrays from '../../../../java/util/Arrays';
import CoordinateFilter from './CoordinateFilter';
import hasInterface from '../../../../hasInterface';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import GeometryComponentFilter from './GeometryComponentFilter';
import Dimension from './Dimension';
import GeometryFilter from './GeometryFilter';
import CoordinateSequenceFilter from './CoordinateSequenceFilter';
import Envelope from './Envelope';
import Assert from '../util/Assert';
var GeometryCollection = /*#__PURE__*/function (_Geometry) {
  function GeometryCollection() {
    var _this;
    _classCallCheck(this, GeometryCollection);
    _this = _callSuper(this, GeometryCollection);
    GeometryCollection.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(GeometryCollection, _Geometry);
  return _createClass(GeometryCollection, [{
    key: "computeEnvelopeInternal",
    value: function computeEnvelopeInternal() {
      var envelope = new Envelope();
      for (var i = 0; i < this._geometries.length; i++) {
        envelope.expandToInclude(this._geometries[i].getEnvelopeInternal());
      }
      return envelope;
    }
  }, {
    key: "getGeometryN",
    value: function getGeometryN(n) {
      return this._geometries[n];
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      var coordinates = new Array(this.getNumPoints()).fill(null);
      var k = -1;
      for (var i = 0; i < this._geometries.length; i++) {
        var childCoordinates = this._geometries[i].getCoordinates();
        for (var j = 0; j < childCoordinates.length; j++) {
          k++;
          coordinates[k] = childCoordinates[j];
        }
      }
      return coordinates;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      var area = 0.0;
      for (var i = 0; i < this._geometries.length; i++) {
        area += this._geometries[i].getArea();
      }
      return area;
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === 'number' && arguments[0] instanceof Geometry) {
        var other = arguments[0];
        var tolerance = arguments[1];
        if (!this.isEquivalentClass(other)) {
          return false;
        }
        var otherCollection = other;
        if (this._geometries.length !== otherCollection._geometries.length) {
          return false;
        }
        for (var i = 0; i < this._geometries.length; i++) {
          if (!this._geometries[i].equalsExact(otherCollection._geometries[i], tolerance)) {
            return false;
          }
        }
        return true;
      } else return _superPropGet(GeometryCollection, "equalsExact", this, 1).apply(this, arguments);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      for (var i = 0; i < this._geometries.length; i++) {
        this._geometries[i].normalize();
      }
      Arrays.sort(this._geometries);
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (this.isEmpty()) return null;
      return this._geometries[0].getCoordinate();
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      var dimension = Dimension.FALSE;
      for (var i = 0; i < this._geometries.length; i++) {
        dimension = Math.max(dimension, this._geometries[i].getBoundaryDimension());
      }
      return dimension;
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_GEOMETRYCOLLECTION;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      var dimension = Dimension.FALSE;
      for (var i = 0; i < this._geometries.length; i++) {
        dimension = Math.max(dimension, this._geometries[i].getDimension());
      }
      return dimension;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      var sum = 0.0;
      for (var i = 0; i < this._geometries.length; i++) {
        sum += this._geometries[i].getLength();
      }
      return sum;
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      var numPoints = 0;
      for (var i = 0; i < this._geometries.length; i++) {
        numPoints += this._geometries[i].getNumPoints();
      }
      return numPoints;
    }
  }, {
    key: "getNumGeometries",
    value: function getNumGeometries() {
      return this._geometries.length;
    }
  }, {
    key: "reverse",
    value: function reverse() {
      var n = this._geometries.length;
      var revGeoms = new Array(n).fill(null);
      for (var i = 0; i < this._geometries.length; i++) {
        revGeoms[i] = this._geometries[i].reverse();
      }
      return this.getFactory().createGeometryCollection(revGeoms);
    }
  }, {
    key: "compareToSameClass",
    value: function compareToSameClass() {
      if (arguments.length === 1) {
        var o = arguments[0];
        var theseElements = new TreeSet(Arrays.asList(this._geometries));
        var otherElements = new TreeSet(Arrays.asList(o._geometries));
        return this.compare(theseElements, otherElements);
      } else if (arguments.length === 2) {
        var _o = arguments[0];
        var comp = arguments[1];
        var gc = _o;
        var n1 = this.getNumGeometries();
        var n2 = gc.getNumGeometries();
        var i = 0;
        while (i < n1 && i < n2) {
          var thisGeom = this.getGeometryN(i);
          var otherGeom = gc.getGeometryN(i);
          var holeComp = thisGeom.compareToSameClass(otherGeom, comp);
          if (holeComp !== 0) return holeComp;
          i++;
        }
        if (i < n1) return 1;
        if (i < n2) return -1;
        return 0;
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      if (hasInterface(arguments[0], CoordinateFilter)) {
        var filter = arguments[0];
        for (var i = 0; i < this._geometries.length; i++) {
          this._geometries[i].apply(filter);
        }
      } else if (hasInterface(arguments[0], CoordinateSequenceFilter)) {
        var _filter = arguments[0];
        if (this._geometries.length === 0) return null;
        for (var _i = 0; _i < this._geometries.length; _i++) {
          this._geometries[_i].apply(_filter);
          if (_filter.isDone()) {
            break;
          }
        }
        if (_filter.isGeometryChanged()) this.geometryChanged();
      } else if (hasInterface(arguments[0], GeometryFilter)) {
        var _filter2 = arguments[0];
        _filter2.filter(this);
        for (var _i2 = 0; _i2 < this._geometries.length; _i2++) {
          this._geometries[_i2].apply(_filter2);
        }
      } else if (hasInterface(arguments[0], GeometryComponentFilter)) {
        var _filter3 = arguments[0];
        _filter3.filter(this);
        for (var _i3 = 0; _i3 < this._geometries.length; _i3++) {
          this._geometries[_i3].apply(_filter3);
        }
      }
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      this.checkNotGeometryCollection(this);
      Assert.shouldNeverReachHere();
      return null;
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_GEOMETRYCOLLECTION;
    }
  }, {
    key: "copy",
    value: function copy() {
      var geometries = new Array(this._geometries.length).fill(null);
      for (var i = 0; i < geometries.length; i++) {
        geometries[i] = this._geometries[i].copy();
      }
      return new GeometryCollection(geometries, this._factory);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      for (var i = 0; i < this._geometries.length; i++) {
        if (!this._geometries[i].isEmpty()) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryCollection;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(Geometry);
export { GeometryCollection as default };
GeometryCollection.constructor_ = function () {
  this._geometries = null;
  if (arguments.length === 0) {} else if (arguments.length === 2) {
    var geometries = arguments[0];
    var factory = arguments[1];
    Geometry.constructor_.call(this, factory);
    if (geometries === null) {
      geometries = [];
    }
    if (Geometry.hasNullElements(geometries)) {
      throw new IllegalArgumentException('geometries must not contain null elements');
    }
    this._geometries = geometries;
  }
};
GeometryCollection.serialVersionUID = -5694727726395021467;